import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_IN_OUT } from '../../utils/motion';
type PlaygroundVisualProps = {
  visual: 'cards' | 'motion' | 'prompt';
};
export function PlaygroundVisual({
  visual
}: PlaygroundVisualProps) {
  const reduce = useReducedMotion();
  if (visual === 'cards') {
    return <div aria-hidden className="absolute inset-0 grid place-items-center bg-surface" data-id="element-276" data-mp="2kpb145lfxglu">
        <div className="relative h-[58%] w-[34%]" data-id="element-277" data-mp="1n3dk6cmpljc0">
          <div className="absolute inset-0 -rotate-[14deg] -translate-x-[40%] rounded-lg bg-ink shadow-md" data-id="element-278" data-mp="1s0vykijhwqre" />
          <div className="absolute inset-0 rotate-0 rounded-lg bg-coral shadow-md" data-id="element-279" data-mp="1wzqf1dtzq38c" />
          <div className="absolute inset-0 rotate-[14deg] translate-x-[40%] rounded-lg bg-coral-soft shadow-md" data-id="element-280" data-mp="21qypmd723un3" />
        </div>
      </div>;
  }
  if (visual === 'motion') {
    return <div aria-hidden className="absolute inset-0 grid place-items-center bg-night" data-id="element-281" data-mp="149qfzvm67kde">
        <div className="flex gap-2.5" data-id="element-282" data-mp="198kysxk518xi">
          {['bg-coral', 'bg-white', 'bg-ink-soft'].map((c, i) => <motion.span key={c} className={`h-3 w-3 rounded-full ${c}`} animate={reduce ? undefined : {
          y: [0, -8, 0]
        }} transition={{
          duration: 0.9,
          ease: EASE_IN_OUT,
          repeat: Infinity,
          repeatDelay: 0.4,
          delay: i * 0.12
        }} data-id="element-283" data-mp="wj8gjhqpjwxl" data-mpi={i} />)}
        </div>
      </div>;
  }
  return <div aria-hidden className="absolute inset-0 grid place-items-center bg-coral-soft" data-id="element-284" data-mp="drpf3fcc0qxo">
      <div className="flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-medium text-rust shadow-sm" data-id="element-285" data-mp="8qryv8avu6yt">
        prompt <span className="text-fg-faint" data-id="element-286" data-mp="3t07qgi2aovo">→</span> prototype
      </div>
    </div>;
}